function startBaseHelper(context){

    context = context || 'body';

    /*******************************************************
     ***************************************** helpers
     *******************************************************/


    /***************************************** target blank */
    $('a.external', context).attr('target', '_blank');

  /*******************************************************
   ***************************************** remove oprphans
   *******************************************************/
  $('p, h1, h2, h3, h4, label, li', context).removeOrphans();
}


function beforeShowPage(){
  /*******************************************************
   ***************************************** objectfit
   *******************************************************/
  if (!Modernizr.objectfit) {
    $('.section-bkg img').each(function () {
      var imgUrl = $(this).prop('src');
      $wrapper = $(this).closest('.section-content');
      if (imgUrl) {
         $wrapper
         .css('backgroundImage', 'url(' + imgUrl + ')')
         .addClass('object-fit');
         $(this).hide();
      }
    });

    $('.section-bkg img').on('load', function(){
      var imgUrl = $(this).prop('src');
      $wrapper = $(this).closest('.section-content');
      if (imgUrl) {
         $wrapper
         .css('backgroundImage', 'url(' + imgUrl + ')')
         .addClass('object-fit');
         $(this).hide();
      }
    });
  }


  /*******************************************************
   ***************************************** full screen sections
   *******************************************************/
  var resizeMainSections = function () {
    var windowHeight = $(window).height();
    $('.section-full').css({'height': (windowHeight - 45) + 'px'});
    $('.row-flex').css({'min-height': (windowHeight - $('.page-header').outerHeight()) + 'px'});
  };
  resizeMainSections();
  $(window).resize(resizeMainSections);


  /*******************************************************
   ***************************************** Loaded image
   *******************************************************/
  $('img[data-src]').each(function(){
   var image = $(this);
    $(this).attr('src', $(this).data('src')).addClass('lazy-load');
    $(this).on('load', function() {
      $(this).addClass('in');
    });
  });


  /*******************************************************
   ***************************************** Fade sections
   *******************************************************/
  YASS();
  $('html').addClass('html-loaded');
  new FadeScrolling();
}

$(document).ready(function() {


  /*******************************************************
   ***************************************** base simple heper inti
   *******************************************************/
  startBaseHelper();


  /*******************************************************
   ***************************************** videoautoplay
   *******************************************************/
   if($('.section-movie-bkg').length > 0){
    setTimeout(function(){
      if (Modernizr.videoautoplay && Modernizr.objectfit) {
        $('.section-movie-bkg').each(function () {
          var $element = $(this);
          var src = $element.data('src');
          $element.append($('<source src="' + src + '" type="video/mp4" />'));
        });
        beforeShowPage();
      } else {
        $('.section-movie-bkg').remove();
        beforeShowPage();
      }
    }, 1000);

   } else{
    beforeShowPage();
   }


  /*******************************************************
   ***************************************** dotdotdot
   *******************************************************/
  $(".ellipsis-text").dotdotdot({
    watch: true
  });


  /*******************************************************
   ***************************************** toggle page header
   *******************************************************/
  if(!$('body').hasClass('scrolled-start')){
    $(document).on('scroll.page-header', function(){
      var scrollTop = $(document).scrollTop();
      if(scrollTop > 50){
        $('body').addClass('scrolled');
      } else {
        $('body').removeClass('scrolled');
      }
    });
  }


  /*******************************************************
   ***************************************** Navbar toggle
   ******************************************************/
  $('.navbar-toggle').click(function(e){
    $(this).toggleClass('collapsed');
    $('.navbar-collapse').toggleClass('in');
    e.preventDefault();
  });


  /*******************************************************
   ***************************************** Player
   *******************************************************/
  plyr.setup(document.querySelectorAll('.js-player'));


  /*******************************************************
   ***************************************** Tooltip
   *******************************************************/
  $('[data-toggle="tooltip"]').tooltip({
    container: 'body'
  });


  /*******************************************************
   ***************************************** Promoted product swiper
   *******************************************************/
  var swiper = new Swiper('.promoted-product-swiper-container', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.promoted-product-swiper-container .swiper-nav-next',
    prevButton: '.promoted-product-swiper-container .swiper-nav-prev',
    slidesPerView: 4,
    loop: false,
    spaceBetween: 0,
    breakpoints: {
      1450: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 2
      },
      740: {
        slidesPerView: 1
      }
    }
  });


  /*******************************************************
   ***************************************** Realization swipers
   *******************************************************/
  var slideLenght = $('.realization-full-swiper-container .swiper-slide').length;
  var realizationFullSwiper = new Swiper('.realization-full-swiper-container', {
    paginationClickable: false,
    nextButton: '.realization-full-swiper-container .swiper-btn-next',
    prevButton: '.realization-full-swiper-container .swiper-btn-prev',
    slidesPerView: 1,
    loop: false
  });

  /*******************************************************
   ***************************************** Realization toggle details
   *******************************************************/

  $('[data-toggle="realization-details-box"]').click(function(e){
    if($(this).hasClass('open')){
      $(this).removeClass('open');
      $('.realization-details').removeClass('open');
    } else {
      $(this).addClass('open');
      $('.realization-details').addClass('open');
    }
  });

  $('[data-toggle="realization-details-text"]').click(function(e){
    if($(this).hasClass('open')){
      $(this).toggleClass('open');
      var windowHeight = $(window).height();
      $('.realization-details-collapse').toggleClass('close');
      $('.realization-details-collapse').mCustomScrollbar("destroy");
    } else {
      $(this).toggleClass('open');
      var windowHeight = $(window).height();
      var height = $('.realization-details-text-header').outerHeight();
      $('.realization-details-collapse').css({'max-height': (windowHeight - height - 420) + 'px'}).toggleClass('close');
      $('.realization-details-collapse').mCustomScrollbar();
    }
    e.preventDefault();
  });
  var windowHeight = $(window).height();
  var height = $('.realization-details-text-header').outerHeight();
  $('.realization-details-collapse').css({'max-height': (windowHeight - height - 420) + 'px'});
  $('.realization-details-collapse').mCustomScrollbar();


  /*******************************************************
   ***************************************** Scroll to next sections
   *******************************************************/
  $('[data-toggle="scroll-to-next-section"]').click(function(e){
    var $nextSection = $(this).parent().next();
    var offsetTop = $nextSection.offset().top - $('.page-header').outerHeight() + 50;
    $('html, body').animate({
        scrollTop: offsetTop
      }, 1000);
    e.preventDefault();
  });


  /*******************************************************
   ***************************************** Scroll to sections
   *******************************************************/
  $('[data-toggle="scroll-to-section"]').click(function(e){
    var section = $(this).attr('href');
    var offsetTop = $(section).offset().top - $('.page-header').outerHeight();
    $('html, body').animate({
        scrollTop: offsetTop
      }, 1000);
    e.preventDefault();
  });


  /*******************************************************
   ***************************************** Form, focus
   *******************************************************/
  $(".form-control").focus(function() {
    $(this).closest('.form-group').addClass('focus').removeClass('filled');
  });
  $(".form-control").blur(function() {
    if($(this).val() !=""){
      $(this).closest('.form-group').addClass('filled');
    }
    $(this).closest('.form-group').removeClass('focus');
  });


  /*******************************************************
   ***************************************** simple validate
   *******************************************************/
    $(".simple-validate").each(function(index){
      $(this).validate();
    });


  /*******************************************************
   ***************************************** static modal
   *******************************************************/
    $("#open-modal").modal('show');


  /*******************************************************
   ***************************************** equal height
   *******************************************************/
  $('.row-grid-blog .article-lead-body').matchHeight({});



  /*******************************************************
   ***************************************** product variant
   *******************************************************/
  $('.nav-product-variant a').click(function(e){
    $(this).parent().siblings().removeClass('active');
    $(this).parent().addClass('active');

    var id = $(this).data('id');
    $('.variant-content').removeClass('active');
    $('.variant-content-' + id).addClass('active');

    e.preventDefault();
  });


  /*******************************************************
   ***************************************** modal
   *******************************************************/
  $('.modal-video-toggle').click(function(e){
    var target = $(this).attr('href');
    $(target).modal('show');
    e.preventDefault();
  });

  $('.modal-video').appendTo('body');
  $('.modal-video').on('shown.bs.modal', function (e) {
    plyr.setup('.modal-video.in .js-player-modal', {
      autoplay: true
    });
  });

  $('.modal-video').on('hide.bs.modal', function (e) {
    var players = plyr.get('.js-player-modal');
    players[0].pause();
  });


  $('.panel-collapse').on('show.bs.collapse', function () {
    $('img[data-demand-src]', $(this)).each(function(){
     var image = $(this);
      $(this).attr('src', $(this).data('demand-src')).addClass('lazy-load');
      $(this).on('load', function() {
        $(this).addClass('in');
      });
    });
  })
  $('.panel-collapse.in').trigger('show.bs.collapse');




  /*******************************************************
   ***************************************** offer catgory more text
   *******************************************************/
  $('.product-lead-collapse').mCustomScrollbar();
  $('a[data-toggle="category-more-text"]').click(function(e){
    $(this).prev().removeClass('hidden');
    $(this).addClass('hidden');
      $('.product-lead-collapse').mCustomScrollbar();
    e.preventDefault();
  });



});


$(document).ready(function() {

  /*******************************************************
   ***************************************** Offer grid
   *******************************************************/
   /*
  if($('.product-grid').length > 0){
    var Shuffle = window.shuffle;
    var shuffle = new Shuffle($('.product-grid')[0], {
      itemSelector: '.col-sm-6'
    });
    shuffle.filter($('.product-grid-filter .active a').attr('data-group'));
    $('.product-grid-filter a').click(function(e){
      if($(this).parent().hasClass('active')){
        return false;
      }
      $(this).parent().siblings().removeClass('active');
      $(this).parent().addClass('active');

      shuffle.filter($(this).attr('data-group'));
      e.preventDefault();
    });

    setTimeout(function(){
      shuffle.update();
    }, 500)
  }
  */

});
